import React from "react";
import { Route, Redirect } from "react-router-dom";

//Used to ensure secure forms are only viewable by coordinators
const ProtectedRoute = ({ path, loggedIn, component: Component, render, ...rest }) => {
    
  return (
    <Route
      {...rest}
      render={props => {
        if (loggedIn === 'false')
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location }
              }}
            />
          );
        return Component ? <Component {...props} /> : render(props);
      }}
    />
  );
};

export default ProtectedRoute;